import React from 'react'

import PerformanceOptions from '../PerformanceOptions.jsx'

export default function MutualFundsPerformanceOptions({
  selectedClass,
  selectedPerformanceFrequency,
  selectedDisplayBenchmark,
  selectedDisplayMorningstar,
  onChangePerformanceType,
  onChangePerformanceFrequency,
  onChangeDisplayBenchmark,
  onChangeDisplayMorningstar,
}) {
  const renderPerformanceTypeOptions = () => {
    return (
      <>
        <option value="nav">NAV</option>
        {!(
          selectedClass &&
          (selectedClass.className === 'R' ||
            selectedClass.className === 'Advisor' ||
            selectedClass.className === 'Institutional2' ||
            selectedClass.className === 'Institutional3' ||
            selectedClass.className === 'Institutional')
        ) ? (
          <option value="pop">POP or W/CDSC</option>
        ) : null}
      </>
    )
  }

  return (
    <PerformanceOptions
      performanceTypeOptions={renderPerformanceTypeOptions}
      primaryBenchmarkName="Primary Benchmark"
      selectedPerformanceFrequency={selectedPerformanceFrequency}
      selectedDisplayBenchmark={selectedDisplayBenchmark}
      selectedDisplayMorningstar={selectedDisplayMorningstar}
      onChangePerformanceType={onChangePerformanceType}
      onChangePerformanceFrequency={onChangePerformanceFrequency}
      onChangeDisplayBenchmark={onChangeDisplayBenchmark}
      onChangeDisplayMorningstar={onChangeDisplayMorningstar}
    />
  )
}
